import {createBrowserRouter, useNavigate} from "react-router-dom";
import App from "./App";
import MissionPage from "./pages/mission/MissionPage";
import NotFoundPage from "./pages/NotFoundPage";
import CandidaturePage from "./pages/Candidature/CandidaturePage";
import MesCandidaturesPage from "./pages/Candidature/MesCandidaturesPage";
import LoginPage from "./features/auth/components/LoginPage";
import CallbackPage from "./features/auth/components/CallbackPage";
import ProtectedRoute from "./components/common/ProtectedRoute";
import HistoriqueBDPage from "./pages/business-developer/HistoriqueBDPage";
import {Role} from "./features/auth/types/auth.types";
import CreateMissionPage from "./pages/mission/CreateMissionPage";
import {useAuth} from "./features/auth/hooks/useAuth";
import {useEffect} from "react";
import ImportMissionPage from "./pages/ImportExcel/ImportMissionPage";

// Composant qui redirige vers la bonne page d'accueil aprs connexion, en fonction du role
const HomeRedirect: React.FC = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (userInfo?.roles?.includes(Role.BD) || userInfo?.roles?.includes(Role.ADMIN)) {
            navigate("/historique", { replace: true });
        } else {
            navigate("/missions", { replace: true });
        }
    }, [userInfo, navigate]);

    return null;
};

export default createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            // Page d'accueil, accessible à tous (protégée mais sans rôle)
            {
                index: true,
                element: (
                    <ProtectedRoute allowedRoles={[Role.CONSULTANT, Role.BD, Role.ADMIN]}>
                        <HomeRedirect />
                    </ProtectedRoute>
                ),
            },
            // Voir toutes les missions (consultant et BD et admin)
            {
                path: "missions",
                element: (
                    <ProtectedRoute allowedRoles={[Role.CONSULTANT, Role.ADMIN, Role.BD]}>
                        <MissionPage />
                    </ProtectedRoute>
                ),
            },
            // Créer une mission (BD et admin)
            {
                path: "creer-mission",
                element: (
                    <ProtectedRoute allowedRoles={[Role.BD, Role.ADMIN]}>
                        <CreateMissionPage />
                    </ProtectedRoute>
                ),
            },
            // Formulaire de description (consultant et admin)
            // Candidatures par consultant
            {
                path: "mescandidatures",
                element: (
                    <ProtectedRoute allowedRoles={[Role.CONSULTANT, Role.ADMIN]}>
                        <MesCandidaturesPage />
                    </ProtectedRoute>
                ),
            },
            // Page de candidature individuelle (consultant et admin)
            {
                path: "candidatures/:id",
                element: (
                    <ProtectedRoute allowedRoles={[Role.CONSULTANT, Role.ADMIN]}>
                        <CandidaturePage />
                    </ProtectedRoute>
                ),
            },
            // Historique BD (BD et admin)
            {
                path: "historique",
                element: (
                    <ProtectedRoute allowedRoles={[Role.BD, Role.ADMIN]}>
                        <HistoriqueBDPage />
                    </ProtectedRoute>
                ),
            },
            {
                path: "import-excel",
                element: (
                    <ProtectedRoute allowedRoles={[Role.ADMIN]}>
                        <ImportMissionPage />
                    </ProtectedRoute>
                ),
            },

            // Connexion et callback ne sont pas protégés
            { path: "connexion", element: <LoginPage /> },
            { path: "callback", element: <CallbackPage /> },
            // 403 Forbidden
            {
                path: "403",
                element: <div>403 - Accès refusé</div>,
            },
            // 404 Not Found
            {
                path: "*",
                element: (
                    <ProtectedRoute>
                        <NotFoundPage />
                    </ProtectedRoute>
                ),
            },
        ],
    },
]);